import { USER_STATUS_COLOR_MODES } from 'cpool-constants';

import { useUserData } from '~/components/Header/menu/hooks/useUserData';
import useUserInfo from '~/hooks/useUserInfo';

export const useStatusColorsEnabled = () => {
    const user = useUserInfo();
    const { data: userData } = useUserData(user?.id);

    return userData?.settings.statusColorMode === USER_STATUS_COLOR_MODES.COLORFUL;
};
